import { ColumnDef, Row } from "@tanstack/react-table"
import { Store } from "../../../hooks/useFetchStores"
import { CreditedMoneyColumn } from "./columns/creditedMoneyColumn"
import { CurrencyImageCell } from "./columns/currencyImageCell"
import { DateAndTimeCell } from "./columns/dateAndTimeCell"
import { MoneyCell } from "./columns/MoneyCell"
import { OrderCell } from "./columns/OrderCell"
import { StatusColumn } from "./columns/statusCell"
import { StoreCell } from "./columns/StoreCell"
import { TableOrder } from "./data/types"


export const getColumns = (
	stores: Store[] | undefined
): { [key: string]: ColumnDef<TableOrder>[] } => ({
	xl: [
		StatusColumn(),
		OrderCell({
			accessorKey: "display_id",
			header: "Orden",
		}),
		...(stores && stores.length > 1
			? [
					StoreCell<TableOrder>({
						accessorKey: "store_name",
						header: "Tienda",
					}),
			  ]
			: []),
		MoneyCell<TableOrder>({
			accessorKey: "expected",
			header: "Solicitado",
		}),
		MoneyCell<TableOrder>({
			accessorKey: "received",
			header: "Recibido",
		}),
		CurrencyImageCell<TableOrder>(),
		DateAndTimeCell({
			accessorKey: "time",
			enableDateFilter: true,
			
		}),
	],
	lg: [
		StatusColumn(),
		OrderCell({
			accessorKey: "display_id",
			header: "Orden",
		}),
		...(stores && stores.length > 1
			? [
					StoreCell<TableOrder>({
						accessorKey: "store_name",
						header: "Tienda",
					}),
			  ]
			: []),
		MoneyCell({
			accessorKey: "expected",
			header: "Solicitado",
		}),
		// CurrencyImageCell(),
		DateAndTimeCell({
			accessorKey: "time",
			enableDateFilter: true,
			
		}),
	],
	md: [
		StatusColumn(),
		...(stores && stores.length > 1
			? [
					StoreCell<TableOrder>({
						accessorKey: "store_name",
						header: "Tienda",
					}),
			  ]
			: []),
		CreditedMoneyColumn({
			enableDateFilter: true,
			
		}),
	],
	sm: [
		StatusColumn(),
		CreditedMoneyColumn({
			enableDateFilter: true,
			
		}),
	],
})
